import { render, staticRenderFns } from "./ResourceSetting.vue?vue&type=template&id=0598e8ea&scoped=true&"
import script from "./ResourceSetting.vue?vue&type=script&lang=js&"
export * from "./ResourceSetting.vue?vue&type=script&lang=js&"
import style0 from "./ResourceSetting.vue?vue&type=style&index=0&id=0598e8ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0598e8ea",
  null
  
)

export default component.exports